import firebase from "firebase";

import "firebase/auth/dist/index.cjs";
import "firebase/database/dist/index.cjs";

const defaultConfig = {
  apiKey: "AIzaSyATtXmgTMJcgYfYqPGQ4-3bg0wqpcc8pLs",
  authDomain: "tapasuites-id.firebaseapp.com",
  databaseURL: "https://tapasuites-id.firebaseio.com",
  projectId: "tapasuites-id",
  storageBucket: "tapasuites-id.appspot.com",
  messagingSenderId: "730777335644"
};

if (!firebase.apps.length) {
  firebase.initializeApp(defaultConfig);
}

//Use Admin SDK
const auth = firebase.auth();
const db = firebase.database();
const functions = firebase.functions();
const store = firebase.firestore();
const storage = firebase.storage();

export { auth, db, functions, storage, store };
